import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/flujos-address-complement`;



export const getAll = async ({page = '', limit = '', nivel = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&nivel=${nivel}`, config)
 return data
}

export const create = async ({flujo = {}}) => {
 const {data} = await axios.post(baseUrl, flujo, config)
 return data
}

export const update = async ({flujo = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, flujo, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}